module.exports = __webpack_public_path__ + "assets/img/ko-0ebc941d.png";